import fetchAPI from '../fetchAPI';
import { LookupItem, LookupUpsertPayload } from './callGetLookups';

export const callUpsertLookup = async (
  payload: LookupUpsertPayload
): Promise<iResponse<{ code: number; data?: LookupItem; message?: string }>> => {
  const response: iResponse<{ code: number; data?: LookupItem; message?: string }> = await fetchAPI({
    method: `POST`,
    route: `lookup`,
    data: payload as unknown as APIData
  });
  return response;
};

export default callUpsertLookup;
